"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconInlineSize = exports.IconSize = exports.IconColor = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var IDUtils_1 = require("../../utils/IDUtils");
var StandardIconUtils_1 = require("../../utils/StandardIconUtils");
var DeprecationUtils_1 = require("../../utils/DeprecationUtils");
var IconColor;
(function (IconColor) {
    IconColor["ACCENT_DARK"] = "accent-dark";
    IconColor["ATTENTION"] = "attention";
    IconColor["DISABLED"] = "disabled";
    IconColor["ERROR"] = "error";
    IconColor["EMPHASIZED"] = "emphasized";
    IconColor["FEATURED"] = "featured";
    IconColor["INFO"] = "info";
    IconColor["INTERACTIVE"] = "interactive";
    IconColor["INTERACTIVE_ALT"] = "interactive-alt";
    IconColor["REVERSED"] = "reversed";
    IconColor["STATIC"] = "static";
    IconColor["SUCCESS"] = "success";
})(IconColor = exports.IconColor || (exports.IconColor = {}));
var IconSize;
(function (IconSize) {
    IconSize["X_SMALL"] = "x-small";
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
})(IconSize = exports.IconSize || (exports.IconSize = {}));
var IconInlineSize;
(function (IconInlineSize) {
    IconInlineSize["TYPE_100"] = "fds-icon-inline-100";
    IconInlineSize["TYPE_200"] = "fds-icon-inline-200";
    IconInlineSize["TYPE_300"] = "fds-icon-inline-300";
    IconInlineSize["TYPE_400"] = "fds-icon-inline-400";
    IconInlineSize["TYPE_500"] = "fds-icon-inline-500";
    IconInlineSize["TYPE_600"] = "fds-icon-inline-600";
    IconInlineSize["TYPE_700"] = "fds-icon-inline-700";
    IconInlineSize["TYPE_800"] = "fds-icon-inline-800";
    IconInlineSize["TYPE_900"] = "fds-icon-inline-900";
})(IconInlineSize = exports.IconInlineSize || (exports.IconInlineSize = {}));
var Icon = function (props) {
    var classes = props.classes, color = props.color, description = props.description, disabled = props.disabled, emphasized = props.emphasized, inline = props.inline, inlineIconSize = props.inlineIconSize, interactive = props.interactive, name = props.name, onClick = props.onClick, size = props.size, title = props.title, before = props.before, otherProps = __rest(props, ["classes", "color", "description", "disabled", "emphasized", "inline", "inlineIconSize", "interactive", "name", "onClick", "size", "title", "before"]);
    var sanitizedName = name ? name.trim().toLowerCase() : '';
    switch (color) {
        case IconColor.INTERACTIVE_ALT:
            DeprecationUtils_1.logDeprecatedProp({
                component: 'Icon',
                propName: 'IconColor',
                seeMsg: 'IconColor.INTERACTIVE_ALT has been deprecated. Please use IconColor.INTERACTIVE instead.',
                versionStart: '1.0.0-beta.130',
                versionEnd: '2.0.0'
            });
            break;
        case IconColor.ACCENT_DARK:
            DeprecationUtils_1.logDeprecatedProp({
                component: 'Icon',
                propName: 'IconColor',
                seeMsg: 'IconColor.ACCENT_DARK has been deprecated. Please use IconColor.STATIC instead.',
                versionStart: '1.0.0-beta.169',
                versionEnd: '2.0.0'
            });
            break;
    }
    if (!StandardIconUtils_1.isIconNameValid(sanitizedName)) {
        throw new Error("Invalid icon name provided: \"" + sanitizedName + "\".");
    }
    var titleId = title ? IDUtils_1.generateRandomId() : undefined;
    var descriptionId = description ? IDUtils_1.generateRandomId() : undefined;
    var useAltText = (description || title);
    var ariaHidden = !useAltText;
    var ariaLabelledBy = (function (title, titleId, desciption, descriptionId) {
        var ids = [];
        title && ids.push(titleId);
        desciption && ids.push(descriptionId);
        return ids.length > 0 ? ids.join(' ') : undefined;
    })(title, titleId, description, descriptionId);
    var classNames = getClassNames(props);
    return (react_1.default.createElement("span", __assign({ className: classNames, onClick: onClick }, otherProps),
        react_1.default.createElement("svg", { role: "img", className: "fds-icon-svg", "aria-labelledby": ariaLabelledBy, "aria-hidden": ariaHidden, key: sanitizedName },
            title && react_1.default.createElement("title", { id: titleId }, title),
            description && react_1.default.createElement("desc", { id: descriptionId }, description),
            react_1.default.createElement("use", { xlinkHref: "#" + sanitizedName }))));
};
Icon.defaultProps = {};
var getClassNames = function (props) {
    var _a;
    var classes = props.classes, color = props.color, disabled = props.disabled, emphasized = props.emphasized, inline = props.inline, inlineIconSize = props.inlineIconSize, interactive = props.interactive, name = props.name, size = props.size, before = props.before, after = props.after;
    return classnames_1.default('fds-icon', "fds-icon-name-" + (name && name.trim().toLowerCase()), (_a = {},
        _a["fds-icon-color-" + (color && color.trim().toLowerCase())] = color,
        _a["fds-icon-" + (size && size.trim().toLowerCase())] = size && !inline,
        _a['fds-icon-inline'] = inline,
        _a[inlineIconSize] = inline && inlineIconSize,
        _a['fds-icon-interactive'] = interactive,
        _a['fds-icon-emphasized'] = emphasized,
        _a['is-disabled'] = disabled,
        _a['fds-icon-inline-before'] = before,
        _a['fds-icon-inline-after'] = after,
        _a), classes);
};
exports.default = Icon;
